<template>
  <div
    am-attr-modal-item
    v-click-outside="() => showAddAttributes = false"
  >
    <div class="_display:flex _flex-wrap:wrap _align-items:center">
      <i-badge
        color="primary"
        v-for="(attr, index) in data.data"
        :key="index"
        :am-tag-badge="attr.id % 10"
        class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
      >
        <p>{{ attr.name }}</p>
        <div class="_display:flex _align-items:center">
          <svg viewBox="0 0 24 24" am-icon style="fill: var(----color);" @click="delAttr(index)">
            <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
      </i-badge>
      <svg
        v-if="changedType === data.type && loading"
        viewBox="0 0 24 24"
        :am-loading="loading"
        am-icon="color"
        class="_margin-left:1/4"
      >
        <use xlink:href="@/assets/icons.svg#preloader" x="0" y="0" width="24" height="24" />
        <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
      </svg>
      <svg
        v-if="changedType !== data.type || (!showAddAttributes && !loading)"
        viewBox="0 0 24 24"
        am-icon="color"
        class="_margin-left:1/4"
        @click="showAttr()"
      >
        <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24" />
        <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
      </svg>
    </div>
    <div v-if="showAddAttributes && !isLoad && changedType === data.type" am-add-attr>
      <hr>
      <div
        v-if="filterAttr && filterAttr.length > 0"
        class="_padding-top:1/2 _padding-bottom:1/2 _display:flex _flex-wrap:wrap _align-items:center"
      >
        <i-badge
          color="primary"
          v-for="attr in filterAttr"
          :key="attr.id"
          :am-tag-badge="attr.id % 10"
          class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
          @click="addAttr(attr)"
        >
          <p>{{ attr.name }}</p>
        </i-badge>
      </div>
      <div v-else class="_margin:1/2">
        No results
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'AttrItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showAddAttributes: false
  }),
  computed: {
    ...mapGetters('attributes', [
      'getFilterAttributes',
      'isLoad'
    ]),
    ...mapState('attributes', ['loading', 'changedType']),
    filterAttr () {
      if (this.getFilterAttributes) {
        return this.getFilterAttributes.filter((elem) => !this.data.data.find(({ id }) => elem.id === id))
      } else return null
    },
    value () {
      return this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    ...mapMutations('attributes', [
      'setChangedType'
    ]),
    ...mapActions('attributes', ['getAttributes']),
    delAttr (index) {
      this.value.splice(index, 1)
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    addAttr (attr) {
      if (this.data.singular) this.value.splice(0, this.value.length)
      this.value.push(attr)
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    },
    async showAttr () {
      this.setChangedType(this.data.type)
      await this.getAttributes()
      this.showAddAttributes = true
    }
  }
}
</script>

<style lang="scss">
[am-attr-modal-item] {
  [am-loading~="true"] {
    animation: rotate 300ms ease-in-out infinite;
  }
  [am-add-attr] .badge[am-tag-badge],
  [am-add-attr] .badge[am-tag-badge] p {
    cursor: pointer;
  }
}
@keyframes rotate {
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
}
</style>
